import type { ElementType, ReactNode } from 'react';

type IconType = ElementType<{ className?: string; 'aria-hidden'?: boolean }>;

export interface DetailItemProps {
    label: string;
    value: ReactNode;
    icon?: IconType;
}

const DetailItem = ({ label, value, icon: IconComponent }: DetailItemProps) => (
    <div className="space-y-1">
        <p className="text-muted-foreground flex items-center text-sm">
            {IconComponent && <IconComponent className="text-muted-foreground mr-2 h-4 w-4" aria-hidden={true} />}
            {label}
        </p>
        <p className="text-sm font-medium text-neutral-900">{value ?? '-'}</p>
    </div>
);

export default DetailItem;
